// extracted by mini-css-extract-plugin
export default {"navContainer":"styles_navContainer__-Ps45","navItem":"styles_navItem__Pnmgu","activeNavItem":"styles_activeNavItem__x3+Kb","icon":"styles_icon__XJvV7"};